// extracted by mini-css-extract-plugin
module.exports = {"content":"content___14LH-","container":"container___3qJaH","text":"text___2ywlV","submitButton":"submitButton___O9c1X"};